import { isAxiosError } from 'axios';
import { IServiceError } from 'core/model/interfaces/service.interface';

export const getFullName = (...params: Array<string>) => params.join(' ').trim();

export const getMappedErrorMessage = (error: unknown, mappedErrors: Record<string, string>, defaultMessage: string) => {
  let errorMessage = '';
  if (isAxiosError<IServiceError>(error)) {
    const { code = '', message = '' } = error.response?.data.error ?? {};
    errorMessage = mappedErrors[code] ?? message;
  }
  return errorMessage || defaultMessage;
};
